<template>
  <v-form ref="form" lazy-validation v-model="valid" v-if="supplier">
    <v-row dense>
      <v-col cols="12" align="center">
        <v-text-field
          label="Наименование поставщика"
          v-model="supplier.name"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="6" align="center">
        <v-checkbox
          label="Используется для формирования цены"
          v-model="supplier.forPrice"
        ></v-checkbox>
      </v-col>
      <v-col cols="6" align="center">
        <v-checkbox
          :disabled="mainSupplier && currentSupplier.id !== mainSupplier.id"
          label="Основной поставщик"
          v-model="supplier.isMain"
        ></v-checkbox>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" align="left">
        <h3>Получение цен и товаров поставщика</h3>
        <v-radio-group v-model="supplier.priceReceiveMethod">
          <v-radio label="По API" value="api"></v-radio>
        </v-radio-group>
      </v-col>
      <v-col cols="6" v-show="currentSupplier.priceReceiveMethod === 'api'">
        <v-text-field
          label="Адрес API"
          v-model="supplier.supplierApi.apiUrl"
        ></v-text-field>
      </v-col>
      <v-col cols="6" v-show="currentSupplier.priceReceiveMethod === 'api'">
        <v-text-field
          label="Пользователь API"
          v-model="supplier.supplierApi.apiUser"
        ></v-text-field>
      </v-col>
      <v-col cols="6" v-show="currentSupplier.priceReceiveMethod === 'api'">
        <v-text-field
          type="password"
          label="Пароль API"
          v-model="supplier.supplierApi.apiPassword"
        ></v-text-field>
      </v-col>
      <v-col cols="6" v-show="currentSupplier.priceReceiveMethod === 'api'">
        <v-text-field
          label="Токен API(опционально)"
          v-model="supplier.supplierApi.apiToken"
        ></v-text-field>
      </v-col>
      <v-col cols="12" v-show="currentSupplier.priceReceiveMethod === 'api'">
        <v-select
          label="Модуль API"
          :items="modules"
          v-model="supplier.supplierApi.moduleId"
          item-title="name"
          item-value="id"
        >
        </v-select>
      </v-col>
    </v-row>
    <v-btn color="primary" @click="update" :disabled="isSaving">
      Сохранить
    </v-btn>
  </v-form>
</template>
<script>
import { mapGetters } from "vuex";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
const SuppliersRepository = RepositoryFactory.get("suppliers");
export default {
  props: ["currentSupplier"],
  data() {
    return {
      isSaving: false,
      supplier: null,
    };
  },
  computed: {
    ...mapGetters(["mainSupplier"]),
  },
  watch: {
    currentSupplier() {
      this.supplier = this.currentSupplier;
    },
  },
  mounted() {
    if (this.currentSupplier) {
      this.supplier = this.currentSupplier;
    }
  },
  methods: {
    async update() {
      this.isSaving = true;
      let response = await SuppliersRepository.update(this.supplier);
      this.isSaving = false;
      if (response.data.status === "success") {
        this.$emit("updateSupplier", response.data.data);
      }
    },
  },
};
</script>
